import { sendGAEvent } from '../utils';

export enum OtherEvents {
  MODAL_GAME_ADD_DATA_SUBMIT = 'modal_game_add_data_submit',
  MODAL_GAME_ADD_DATA_APPEARANCE = 'modal_game_add_data_appearance',
  AB_TEST_ASSIGNMENT = 'ab_test_assignment',
}

interface IABTestAssignmentEvent {
  test_name: string;
  test_version: string;
  test_group: string;
}

/**
 * @param data - The data to be sent with the event.
 * @description This function sends a Google Analytics event when user click on submit button on
 * the gender popup.
 * It uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `gender_popup_submit` and the category is `other`.
 */
export const sendOtherModalGameAddDataSubmitEvent = (fields: string[]) => {
  sendGAEvent(OtherEvents.MODAL_GAME_ADD_DATA_SUBMIT, {
    event_category: 'other',
    fields: fields.join('/'),
  });
};

/**
 * @param data - The data to be sent with the event.
 * @description This function sends a Google Analytics event when user click on submit button on
 * the gender popup.
 * It uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `gender_popup_submit` and the category is `other`.
 */
export const sendOtherModalGameAddDataAppearanceEvent = (fields: string[]) => {
  sendGAEvent(OtherEvents.MODAL_GAME_ADD_DATA_APPEARANCE, {
    event_category: 'other',
    fields: fields.join('/'),
  });
};

/**
 * @param data - The data to be sent with the event.
 * @description This function sends a Google Analytics event when a user is assigned to an AB test.
 * It uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `ab_test_assignment` and the category is `other`.
 * The data object contains the test_name, test_version, test_group
 */
export const sendOtherABTestAssignmentEvent = (
  data: IABTestAssignmentEvent
) => {
  sendGAEvent(OtherEvents.AB_TEST_ASSIGNMENT, {
    event_category: 'other',
    ...data,
  });
};
